import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchange = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sessionId = params.get("session_id");
      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        setUser(data.user);
        // Strip the hash from the URL and go where the user was originally headed.
        // We use whatever path the OAuth provider returned us to, falling back to
        // /discovery for legacy callers.
        const returnPath = window.location.pathname || "/discovery";
        window.history.replaceState(null, "", returnPath);
        navigate(returnPath === "/auth" || returnPath === "/" ? "/discovery" : returnPath, {
          replace: true,
          state: { user: data.user },
        });
      } catch (e) {
        navigate("/auth", { replace: true });
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-screen">
      <div className="text-stone-600 font-display text-lg">Signing you in…</div>
    </div>
  );
}
